const config: any = {};

if(window.serverUri) {
    config.graphqlUri = window.serverUri + '/graphql';
} else {
    config.graphqlUri = document.location.origin+'/graphql';
}
console.log('daybook config',config);
export default config;
